var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hero-2"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "info-container"
  }, [_c('div', {
    staticClass: "info-wrapper"
  }, [_c('div', {
    staticClass: "heading-1",
    domProps: {
      "innerHTML": _vm._s(_vm.field.value.text)
    }
  }), _c('div', {
    staticClass: "description heading-3-regular",
    domProps: {
      "innerHTML": _vm._s(_vm.field.value.text2)
    }
  })])]), _c('div', {
    staticClass: "asset-container"
  }, [_c('div', {
    staticClass: "asset-wrapper"
  }, [_c('img', {
    directives: [{
      name: "scroll-animate",
      rawName: "v-scroll-animate"
    }],
    attrs: {
      "src": _vm.field.value.image,
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "description description-mobile heading-3-regular",
    domProps: {
      "innerHTML": _vm._s(_vm.field.value.text2)
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }